import type { PlatformLogoProps } from './types'
import LogoSvg from '../../assets/platform-logos/etsy.svg?react'
import { chakra } from '../../chakra'
import { getLogoProps } from './use-logo-props'
import * as React from 'react'

const Logo = chakra(LogoSvg)

export const EtsyLogo = React.forwardRef<SVGSVGElement, PlatformLogoProps>(
  function EtsyLogo(props, ref) {
    const logoProps = getLogoProps(props)

    return <Logo {...logoProps} ref={ref} />
  },
)
